import { IMercadoPagoApiResponse } from '../IApiResponses';
import { PSEPaymentMethods } from '../IDataMappings';

const mpPSEPaymentOptionsMapper = {
  response(data: IMercadoPagoApiResponse[]): PSEPaymentMethods {
    const pseOptions = data.filter(method => method.id === 'pse');
    return { pseMethods: pseOptions.length > 0 ? pseOptions[0].financial_institutions : [] };
  },
};

export default mpPSEPaymentOptionsMapper;
